import { useQuery } from '@tanstack/react-query';

import { type EntityLookupOptions, Search } from '@air/api';
import { type WorkspaceInfo } from '@air/api/types';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const PRIVATE_FILTERS_ENTITIES = 'PRIVATE_FILTERS_ENTITIES';

export const getPrivateFiltersEntitiesKey = (options: EntityLookupOptions, workspaceId?: WorkspaceInfo['id']) => [
  PRIVATE_FILTERS_ENTITIES,
  { workspaceId, ...options },
];

export const useGetPrivateFiltersEntities = (options: EntityLookupOptions) => {
  const { currentWorkspace } = useCurrentWorkspace();

  return useQuery({
    queryKey: getPrivateFiltersEntitiesKey(options, currentWorkspace?.id),

    queryFn: () => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      return Search.getEntityLookups({ workspaceId, options });
    },
    staleTime: 1000 * 60 * 60 * 1,
    enabled: !!currentWorkspace?.id,
  });
};
